import React from 'react';
import SEO from '../components/SEO';
import './About.scss';

const TermsAndConditions: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Tanda Grampanchayat',
    description:
      'तांडा ग्रामपंचायत - गोंदिया जिल्ह्यातील गोंदिया तालुक्यातील आधिकारिक ग्रामपंचायत',
    url: 'https://gptandagondia.org.in',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Tanda',
      addressLocality: 'Gondia',
      addressRegion: 'Gondia',
      postalCode: '441601',
      addressCountry: 'IN',
    },
  };

  return (
    <div className="about-page">
      <SEO
        title="अटी व शर्ती | तांडा ग्रामपंचायत"
        description="तांडा ग्रामपंचायतच्या अधिकृत वेबसाइटच्या वापरासंबंधी अटी व शर्ती – माहितीची अचूकता, जबाबदारीची मर्यादा, कॉपीराइट आणि इतर कायदेशीर बाबी."
        keywords="अटी व शर्ती, Terms and Conditions, तांडा ग्रामपंचायत वेबसाइट नियम, Disclaimer"
        ogTitle="अटी व शर्ती | तांडा ग्रामपंचायत"
        ogDescription="तांडा ग्रामपंचायत वेबसाइटच्या वापरासंबंधी अटी व जबाबदारीची मर्यादा."
        canonicalUrl="https://gptandagondia.org.in/terms-and-conditions"
        structuredData={structuredData}
      />
      <div className="about-container">
        <h1>अटी व शर्ती</h1>

        <p>
          या वेबसाइटचा वापर करून आपण खालील अटी व शर्ती मान्य करता. कृपया संपूर्ण मजकूर
          काळजीपूर्वक वाचा; वेबसाइटचा पुढील वापर आपण या अटींना संमती दिल्याचे मानले जाईल.
        </p>

        <h2>१. वेबसाइटचा उद्देश</h2>
        <p>
          ही वेबसाइट तांडा ग्रामपंचायतच्या अधिकृत माहिती, योजना, उपक्रम आणि संपर्क
          माहिती नागरिकांपर्यंत पोहोचवण्यासाठी तयार करण्यात आली आहे. येथे दिलेली माहिती
          मुख्यत्वे माहितीपर असून, ती कायदेशीर सल्ला मानू नये.
        </p>

        <h2>२. माहितीची अचूकता</h2>
        <p>
          वेबसाइटवरील माहिती अद्ययावत ठेवण्यासाठी प्रयत्न केले जातात, तरीही काही
          वेळेस तांत्रिक किंवा टंक चुका, कालबाह्य माहिती किंवा अपूर्ण माहिती राहू शकते.
          कोणत्याही अधिकृत कामकाजासाठी कृपया संबंधित शासकीय कागदपत्रे किंवा कार्यालयाशी
          थेट संपर्क साधा.
        </p>

        <h2>३. वापरकर्त्यांची जबाबदारी</h2>
        <p>वेबसाइटचा वापर करताना आपण खालील गोष्टींचे पालन कराल:</p>
        <ul>
          <li>कोणतीही बेकायदेशीर, आक्षेपार्ह किंवा अपमानास्पद माहिती पाठवणार नाही</li>
          <li>वेबसाइटची सुरक्षा भेदण्याचा किंवा प्रणालीस हानी पोहोचवण्याचा प्रयत्न करणार नाही</li>
          <li>इतरांच्या वैयक्तिक माहितीचा गैरवापर करणार नाही</li>
        </ul>

        <h2>४. कॉपीराइट आणि बौद्धिक संपदा</h2>
        <p>
          वेबसाइटवरील मजकूर, लोगो, छायाचित्रे आणि इतर साहित्य हे तांडा ग्रामपंचायत किंवा
          संबधित हक्कधारकांच्या मालकीचे आहे. अधिकृत परवानगीशिवाय त्याची पुनर्वापर,
          कॉपी, वितरण किंवा व्यावसायिक उपयोग करणे मनाई आहे.
        </p>

        <h2>५. बाह्य दुवे (External Links)</h2>
        <p>
          वेबसाइटवर इतर सरकारी किंवा उपयुक्त वेबसाइट्सचे दुवे देण्यात आले असू शकतात.
          त्या वेबसाइट्सवरील सामग्री, गोपनीयता धोरण किंवा इतर अटींसाठी तांडा
          ग्रामपंचायत जबाबदार राहणार नाही.
        </p>

        <h2>६. जबाबदारीची मर्यादा (Limitation of Liability)</h2>
        <p>
          वेबसाइटच्या वापरामुळे किंवा माहितीवर अवलंबून राहिल्याने झालेल्या कोणत्याही
          थेट, अप्रत्यक्ष, अनुषंगिक किंवा विशेष नुकसानीसाठी तांडा ग्रामपंचायत कोणत्याही
          परिस्थितीत जबाबदार राहणार नाही.
        </p>

        <h2>७. अटींमध्ये बदल</h2>
        <p>
          या अटी व शर्ती वेळोवेळी बदलल्या जाऊ शकतात. अशा बदलांची नोंद या पानावर
          करण्यात येईल. बदलांनंतरही वेबसाइटचा वापर केल्यास आपण सुधारित अटी मान्य केल्या
          असे समजले जाईल.
        </p>

        <h2>८. लागू कायदा आणि अधिकार क्षेत्र</h2>
        <p>
          या अटी व शर्तींचे स्पष्टीकरण आणि अंमलबजावणी भारतातील प्रचलित कायद्यांनुसार
          होईल. कोणत्याही वादाचा निपटारा करण्यासाठी सक्षम न्यायालय म्हणून संबंधित
          जिल्हा न्यायालयाचा अधिकार राहील.
        </p>

        <h2>९. संपर्क</h2>
        <p>
          या अटी व शर्तींबद्दल काही शंका किंवा सूचना असल्यास, कृपया वेबसाइटवरील
          "संपर्क" पानाद्वारे किंवा ग्रामपंचायत कार्यालयात भेट देऊन आपला अभिप्राय नोंदवा.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
